import Modal from './modal'
import CalendarPrice from './calendar-price'
import CityPicker from './city-picker'
import Calendar from './calendar'
import Loading from './loading/car'
import LoadingDotMove from './loading/dot-move'
import AlbumUpload from './upload/album'
import VideoView from './video-view'
import ImageGroup from './image-group'
import TextView from './text-view'
import Gender from './gender'
import Emoji from './emoji'
import FileUpload from './file-upload'
import AliPlay from './aliplay'
import CampCode from './camp-code'

export { Modal }
export { Calendar }
export { CalendarPrice }
export { CityPicker }
export { Loading }
export { AlbumUpload }
export { LoadingDotMove }
export { VideoView }
export { ImageGroup }
export { TextView }
export { Gender }
export { Emoji }
export { FileUpload }
export { AliPlay }
export { CampCode }

export default {
  Calendar,
  CalendarPrice,
  CityPicker,
  Modal,
  Loading,
  AlbumUpload,
  LoadingDotMove,
  VideoView,
  ImageGroup,
  TextView,
  Gender,
  Emoji,
  FileUpload,
  AliPlay,
  CampCode
}



// WEBPACK FOOTER //
// ./src/components/index.js